import { Checkbox, Form, FormInstance, Typography } from 'antd';
import { useIntl } from 'react-intl';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import { CheckboxGroupButtons } from '@/components/_common';
import MoreOptions from './MoreOptions';
import {
  QuestCustomerWithoutMovementFormValues,
  QuestWorkOrderSituationsFilter,
} from '@/core/domain/questReport/Reports/CustomerWithoutMovement/CustomerWithoutMovement.types';

interface Props {
  form: FormInstance<QuestCustomerWithoutMovementFormValues>;
}

export default function CustomerWithoutMovementForm({ form }: Props) {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;
  const osSituationOptions = [
    {
      value: QuestWorkOrderSituationsFilter.open,
      label: intl({ id: 'CustomerWithoutMovement.option.open' }),
    },
    {
      value: QuestWorkOrderSituationsFilter.authorized,
      label: intl({ id: 'CustomerWithoutMovement.option.authorized' }),
    },
    {
      value: QuestWorkOrderSituationsFilter.closed,
      label: intl({ id: 'CustomerWithoutMovement.option.closed' }),
    },
  ];
  return (
    <Form form={form} layout="vertical">
      <ReportSelectMonthFields form={form} />

      <Form.Item
        name="workOrderSituationsFilter"
        label={
          <Title level={5} style={{ margin: '0' }}>
            {intl({ id: 'CustomerWithoutMovement.label.OSSituation' })}
          </Title>
        }
        initialValue={[QuestWorkOrderSituationsFilter.closed]}
      >
        <CheckboxGroupButtons options={osSituationOptions} />
      </Form.Item>

      <Form.Item name="showInactiveCustomers" valuePropName="checked">
        <Checkbox>
          {intl({ id: 'CustomerWithoutMovement.checkbox.inactiveCustomers' })}
        </Checkbox>
      </Form.Item>

      <MoreOptions />
    </Form>
  );
}
